import React from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import desktopActionBarStyles from '../DesktopActionBar.scss';

interface Props {
  index: number;
}

const FluidMargin: React.FC<Props> = ({ index }) => (
  <Flex
    className={classnames(
      desktopActionBarStyles['fluid-margin'],
      desktopActionBarStyles[`fluid-margin-${index}`]
    )}
  />
);

export default FluidMargin;
